import React, { Component } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Footer from '../index/Footer';
import Header from '../index/Header';

const styles = {
	paper: {
		margin: 20,
		marginTop: 30,
		padding: 10,
		height: 500
	},
	container: {
		textAlign: 'center'
	},
	red: {
		color: 'darkred',
		fontSize: '1.2em'
	},
	button: {
		textAlign: 'center',
		marginTop: 30
	},
	textField: {
		marginLeft: '10px',
		marginRight: '10px',
		width: 200
	}
};

const Logo = styled.img`
	max-height: 80px;
	margin-top: 50px;

	@media (max-width: 600px) {
		max-height: 70px;
		margin-top: 10px;
	}
`;

const LoginText = styled.p`
	color: #c655d6;
	margin-bottom: 24px;
	font-weight: bold;
	text-transform: uppercase;
	text-align: center;
	font-size: 18px;

	@media (max-width: 600px) {
		margin-bottom: 4px;
	}
`;

class ResetPassword extends Component {
	constructor(props) {
		super(props);

		this.history = this.props.history;
	}

	state = {
		canSubmit: false,
		newPassword: '',
		confirmNewPassword: ''
	};

	componentDidMount() {
		document.title = 'Forgot Password | Chekkit';
	}

	componentWillUnmount() {
		document.body.className = document.body.className.replace(
			'red-background',
			''
		);
	}

	disableButton = () => {
		this.setState({ canSubmit: false });
	};

	enableButton = () => {
		this.setState({ canSubmit: true });
	};

	handleChange = (name) => (event) => {
		this.setState({
			[name]: event.target.value
		});

		if (
			event.target.value &&
			this.state.newPassword &&
			this.state.confirmNewPassword
		) {
			this.enableButton();
		} else {
			this.disableButton();
		}
	};

	submitNewPasswordForPasswordReset = async () => {
		this.setState({ canSubmit: false });
		const { newPassword, confirmNewPassword } = this.state;
		const { token } = this.props.match.params;
		const res = await axios.post('/api/reset-password', {
			newPassword,
			confirmNewPassword,
			token
		});
		const { message } = res.data;

		this.setState({ message });
	};

	renderError = () => {
		if (this.state.message) {
			if (
				this.state.message ===
				'Your password has been updated. You may now login'
			) {
				return (
					<div>
						Password updated you may now{' '}
						<a href="https://enterprise.chekkit.io/login">login</a>
					</div>
				);
			}
			return `* ${this.state.message}`;
		}

		return '';
	};

	render() {
		return (
			<div>
				<Header />
				<Paper zDepth={1} style={styles.paper}>
					<div className="container" style={styles.container}>
						<div className="row">
							<div className="col s12">
								<Logo src="/img/chekkit-logo.svg" />
								<LoginText>Enter your new password</LoginText>
								<div className="row">
									<form>
										<div className="row">
											<TextField
												name="newPassword"
												placeholder="New Password"
												type="password"
												onChange={this.handleChange(
													'newPassword'
												)}
												style={styles.textField}
											/>
											<TextField
												name="confirmNewPassword"
												placeholder="Confirm New Password"
												type="password"
												onChange={this.handleChange(
													'confirmNewPassword'
												)}
												style={styles.textField}
											/>

											<div className="row">
												{' '}
												<Button
													style={styles.button}
													size="large"
													variant="contained"
													color="primary"
													disabled={
														!this.state.canSubmit
													}
													onClick={
														this
															.submitNewPasswordForPasswordReset
													}
												>
													Submit
												</Button>
											</div>
										</div>
									</form>
									<p
										style={{
											...styles.container,
											...styles.red
										}}
									>
										{this.renderError()}
									</p>
								</div>
							</div>
						</div>
					</div>
				</Paper>
				<Footer />
			</div>
		);
	}
}

export default withRouter(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/register/ResetPassword.js